export enum AbnormalStatus {
    All = 0,
    Abnormal = 1
}